import { render, staticRenderFns } from "./DetailsPricing.vue?vue&type=template&id=5eaf5b2a&scoped=true&"
import script from "./DetailsPricing.vue?vue&type=script&lang=js&"
export * from "./DetailsPricing.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPricing.vue?vue&type=style&index=0&id=5eaf5b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaf5b2a",
  null
  
)

export default component.exports